import type { JsonScimGeneratedToken } from "authentication/js/api/scim-tokens.api";
import { getScimTokens } from "authentication/js/api/scim-tokens.api";
import { createLoadingPromiseV2 } from "core/store/store-utils";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

const MAX_ACTIVE_SCIM_TOKENS = 2;

export const useScimStore = defineStore("feature/authentication/scim", () => {
  const tokens = ref<Array<JsonScimGeneratedToken>>([]);

  async function retrieveScimTokens() {
    tokens.value = await getScimTokens();
  }

  const scimTokens = computed(() => tokens.value);
  const canCreateNewToken = computed(() =>
    tokens.value
      .filter(token => token.status === "ACTIVE")
      .length < MAX_ACTIVE_SCIM_TOKENS,
  );

  async function generateNewToken() {
    // TODO This is going to be implemented on SBA-11516
    tokens.value.push({
      id: 999,
      last4DigitToken: "1234",
      issueDate: "2026-01-01",
      status: "ACTIVE",
      rawToken: "SnuE_aYu6GbAU3qGxW6iVOAveO17lhZkm42bLIejSpI",
      formattedIssueDate: "01 Jan 2026",
    });
  }

  const loadingPromise = createLoadingPromiseV2(retrieveScimTokens);

  return {
    tokens,
    scimTokens,
    generateNewToken,
    canCreateNewToken,
    isReady: loadingPromise,
  };
});
